<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">A<span class="small">CKNOWLEDGEMENTS</span></p>
<p class="noindent">Thank you to my family. You are treasures in my heart.</p>
<p class="indent">Thank you to everyone who shared their stories and those of their families with me. Your generosity made this book possible.</p>
<p class="indent">A special thank-you to folklorist Susan Hill and local historian Donna McCauley, the two best Weatherford natives I know.</p>
<p class="indent">Thank you to my dear friend Mark Elliott Fults for your encouragement. Thanks to my editor, Ben Gibson, who works with Arcadia Publishing and The History Press.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgements.vue?6704239f